import React from 'react'
import Link from 'base/react/components/link'
import Banner from 'base/components/layout/banners/banner_from_config'
import Hub from 'base/hub'
import Event from 'base/event'
import { MOBILE_HEIGHT, DESKTOP_HEIGHT } from 'base/lib/banners'

function handleBannerLinkClick(targetUrl) {
  Hub.pub(Event.Navigation.BANNER_LINK_CLICK, {
    target_url: targetUrl,
  })
}

export default function OutOfMarketInternationalBanner({ platform }) {
  return (
    <Banner height={platform === 'desktop' ? DESKTOP_HEIGHT : MOBILE_HEIGHT}>
      <div>
        We’ll let you know when we ship to your country.&nbsp;
        {platform === 'mobile' && <br />}
        <Link
          inheritColor
          className="international-banner__link"
          href="/international"
          onClick={() => handleBannerLinkClick('/international')}
        >
          Stay up to date&nbsp;
        </Link>
        on international shipping.
      </div>
    </Banner>
  )
}
